import { getXiaomanSyncMember, upXiaomanIsOpen, upXiaomanAccount, upXiaomanUserBind } from '@/services/configXiaoman'
import { getPeronsDatas } from '@/services/quit'

export default {
  namespaced: true,
  state: {
    columns: [{
      title: '小满成员',
      key: 'xiaoman'
    }, {
      title: '对应星轨成员',
      key: 'westartrack'
    }],
    listDatas: [],
    memberOptions: [],

    membersLoading: false
  },
  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_MEMBER_OPTIONS (state, data) {
      state.memberOptions = data
    },
    SET_LOADING (state, data) {
      state.membersLoading = data
    }
  },

  actions: {
    async fetchPeronsDatas ({ commit }) {
      let chain = await getPeronsDatas()
      chain
        .params({
          pk: 'inquiry-followup'
        })
        .config({ tip: false, warn: false })
        .onSuccess((res = {}) => {
          commit('SET_MEMBER_OPTIONS', res.list)
        })
        .fetch()
      return chain
    },
    async fetchXiaomanSyncMember ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getXiaomanSyncMember()
      chain
        .params(params)
        .config({ tip: false })
        .onSuccess((res = {}) => {
          commit('SET_LOADING', false)
          commit('setListDatas', res.xiaomanuserassoc)
        })
        .onNetSuccess(res => {
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    async setXiaomanIsOpen ({ commit }, params) {
      let chain = await upXiaomanIsOpen()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async setXiaomanAccount ({ commit }, params) {
      let chain = await upXiaomanAccount()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async setXiaomanUserBind ({ commit }, params) {
      let chain = await upXiaomanUserBind()
      chain
        .params(params)
        .config({ tip: false })
        .fetch()
      return chain
    }
  }
}
